'use client';

import Image from 'next/image';
import { useTranslation } from '@/i18n/LocaleProvider';

export default function PersonPhoto({ name, role, alt, ...props }) {
  const t = useTranslation();
  return (
    <Image
      {...props}
      alt={t(
        alt ||
          (role ? 'Foto de {name}, {role} de Bison Agents' : 'Foto de {name}'),
        { name, role: t(role) }
      )}
    />
  );
}
